import React, { Component, PropTypes } from 'react';
import context from './src/utils/context';

import Alt from 'alt';
import Flux from '@jimpick/spectacle/src/flux/alt';

import 'normalize.css';

const flux = new Flux();
Alt.debug('flux', flux);

class Spectacle extends Component {

  static propTypes = {
    params: PropTypes.object.isRequired,
    nextLevel: PropTypes.string,
    deckInterface: PropTypes.string.isRequired,
    preload: PropTypes.func.isRequired
  };

  static contextTypes = {
    location: PropTypes.object,
    program: PropTypes.object,
    presenter: PropTypes.bool,
    setActiveSession: PropTypes.func.isRequired,
    session: PropTypes.object
  };

  static childContextTypes = {
    levelId: PropTypes.string,
    level: PropTypes.object,
    params: PropTypes.object
  };

  getChildContext () {
    const { params } = this.props;
    const { program: { levels }, session: { currentLevel } } = this.context;
    const levelId = params.levelId || currentLevel || '1';
    const level = levels[levelId];
    return {
      levelId,
      level,
      params
    };
  }

  componentWillMount () {
    const { deckInterface, preload } = this.props;
    const { session: { currentLevel } } = this.context;
    if (deckInterface === 'classroomDisplay') {
      preload({ level: currentLevel });
    }
  }

  exitSession () {
    const { setActiveSession } = this.context;
    setActiveSession('none');
  }

  render() {
    const { params, nextLevel } = this.props;
    const { program: { levels }, session: { configuration, currentLevel } } = this.context;
    const levelId = params.levelId || currentLevel || '1';
    const level = levels[levelId];
    if (!level) {
      return (
        <div>
          <h2>Unable to load data</h2>
            <button
                className="btn btn-sm btn-default"
                onClick={::this.exitSession}>
              Exit to Programs
            </button>
        </div>
      );
    }
    const { deck: Deck } = level;
    return <Deck nextLevel={nextLevel} configuration={configuration} />;
  }
}

const SpectacleContext = context(
  Spectacle,
  {
    flux
  }
);

export default SpectacleContext;



// WEBPACK FOOTER //
// ./src/views/session/presentation/spectacle-ppa/index.jsx